import request from '@/utils/request'

// 企微客服列表
export function enterpriseWeChatCustomerServiceList(params = {}) {
  return request({
    url: '/workWechat/customer/list',
    method: 'get',
    params
  })
}

// 企微客服添加
export function enterpriseWeChatCustomerServiceAdded(data = {}) {
  return request({
    url: '/workWechat/customer/add',
    method: 'post',
    data
  })
}

// 企微客服修改
export function enterpriseWeChatCustomerServiceModification(data = {}) {
  return request({
    url: '/workWechat/customer/update',
    method: 'post',
    data
  })
}

// 企微客服删除
export function enterpriseWeChatCustomerServiceDelete(data = {}) {
  return request({
    url: '/workWechat/customer/destroy',
    method: 'post',
    data
  })
}

// 手机列表
export function mobilePhoneList(params = {}) {
  return request({
    url: '/workWechat/phone/list',
    method: 'get',
    params
  })
}

// 手机添加
export function mobilePhoneAddition(data = {}) {
  return request({
    url: '/workWechat/phone/add',
    method: 'post',
    data
  })
}

// 手机修改
export function mobilePhoneModification(data = {}) {
  return request({
    url: '/workWechat/phone/update',
    method: 'post',
    data
  })
}

// 手机删除
export function mobilePhoneDeletion(data = {}) {
  return request({
    url: '/workWechat/phone/destroy',
    method: 'post',
    data
  })
}

// 配置列表
export function configurationList(params = {}) {
  return request({
    url: '/workWechat/config/list',
    method: 'get',
    params
  })
}

// 配置添加
export function configurationAdd(data = {}) {
  return request({
    url: '/workWechat/config/add',
    method: 'post',
    data
  })
}

// 配置删除
export function configurationDeletion(data = {}) {
  return request({
    url: '/workWechat/config/destroy',
    method: 'post',
    data
  })
}

// 错误列表
export function errorList(params = {}) {
  return request({
    url: '/workWechat/error/list',
    method: 'get',
    params
  })
}

// 错误添加
export function errorAdding(data = {}) {
  return request({
    url: '/work_wechat_error/add',
    method: 'post',
    data
  })
}
// 错误列表
export function errorListre(params = {}) {
  return request({
    url: '/common/failJobList',
    method: 'get',
    params
  })
}
// 错误详情
export function errorDetail(params = {}) {
  return request({
    url: '/common/failJobDetail',
    method: 'get',
    params
  })
}
